import { Text, TextStyle } from 'pixi.js';
import { FONT } from '@/config/constants';
import { Palette } from '@/config/palette';

export interface TextOpts {
  size?: number;
  color?: number;
  weight?: TextStyle['fontWeight'];
  font?: string;
  align?: TextStyle['align'];
  letterSpacing?: number;
  stroke?: { color: number; width: number };
  dropShadow?: boolean;
  wordWrapWidth?: number;
}

/** Create a Pixi Text with project defaults. Anchor defaults to centre. */
export function makeText(content: string, opts: TextOpts = {}): Text {
  const style = new TextStyle({
    fontFamily: opts.font ?? FONT.ui,
    fontSize: opts.size ?? 18,
    fontWeight: opts.weight ?? '700',
    fill: opts.color ?? Palette.text,
    align: opts.align ?? 'center',
    letterSpacing: opts.letterSpacing ?? 0,
    wordWrap: opts.wordWrapWidth != null,
    wordWrapWidth: opts.wordWrapWidth ?? 0,
  });
  if (opts.stroke) {
    style.stroke = { color: opts.stroke.color, width: opts.stroke.width, join: 'round' };
  }
  if (opts.dropShadow) {
    style.dropShadow = {
      color: 0x000000,
      alpha: 0.45,
      blur: 4,
      distance: 2,
      angle: Math.PI / 2,
    };
  }
  const t = new Text({ text: content, style });
  t.anchor.set(0.5);
  t.resolution = 2;
  return t;
}

/** Title style helper (display font). */
export function makeTitle(content: string, size = 30, color: number = Palette.text): Text {
  return makeText(content, {
    font: FONT.display,
    weight: '900',
    size,
    color,
    letterSpacing: 0.5,
    dropShadow: true,
  });
}
